import React, { useEffect, useState } from 'react';
import { Nav } from 'reactstrap';
import iconLegal from "../../assets/icon_legal.svg";
import iconDarkMode from "../../assets/dark_mode.svg";
import iconLightMode from "../../assets/light_mode.svg";
import IconMonuments from "../../assets/monument.svg";
import report from "../../assets/report.svg"
import show from "../../assets/show.svg"
import hide from "../../assets/hide.svg"
import logo from "../../assets/oc-logo.png"
import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme, GlobalStyles } from '../../themes/global-style-components/theme';
import LayersIcon from '@mui/icons-material/Layers';
import BuildIcon from '@mui/icons-material/Build';
import InfoIcon from '@mui/icons-material/Info';
import { appVersion } from '../../config';
import YouTubeIcon from '@mui/icons-material/YouTube';
import MonumentMenu from '../menus/monuments/Menu';
import ToolsMenu from '../menus/tools/Menu';
import ComputerIcon from '@mui/icons-material/Computer';
const drawerWidth = 100;

const NavMenu = ({ setPage, page, setTool,hideDrawer, setHideDrawer, setOpen, pageConfig }) => {

  const [theme, setTheme] = useState("light");
  const isDarkTheme = theme === "dark";

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [monMenuAnchorEl, setMonMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const monMenuOpen = Boolean(monMenuAnchorEl);

  const handleClose = () => {
    setAnchorEl(null);
    setMonMenuAnchorEl(null);
  }

  const toggleTheme = () => {
    const updatedTheme = isDarkTheme ? "light" : "dark";
    setTheme(updatedTheme);
    localStorage.setItem("theme", updatedTheme);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const prefersDark =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (savedTheme && ["dark", "light"].includes(savedTheme)) {
      setTheme(savedTheme);
    } else if (prefersDark) {
      setTheme("dark");
    }
  }, []);


  const openMenu = (e) => {
    setAnchorEl(e.currentTarget);
  }
  const openMonumentMenu = (e) => {
    setMonMenuAnchorEl(e.currentTarget);
  }

  const layers = () => {
    setPage('layers');
  };

  const tools = (tool) => {
    handleClose();
    setTool(tool);
    setPage('tools');
  };

  const identify = () => {
    setPage('identify')
  };

  const selection = () => {
    setPage('selection')
  };

  const monuments = (tool) => {
    handleClose();
     setTool(tool);
    setPage('monuments')
  };

    const seniorInspReview = (tool) => {
    handleClose();
     setTool(tool);
    setPage('seniorInspReview')
  };

  return (
    <div className='navbar'>
      <Nav className='navbar__nav nav' width={`calc(100% - ${drawerWidth}px)`} >
        <ul className="nav__list">
          <li className='logo'>
            <a href={`${process.env.REACT_APP_BASE_DOMAIN_URL}/home`} target="_blank" rel="noreferrer"><img src={logo} alt="Orange County Parcel Check"/></a>
          </li>
          {pageConfig.widgets.project && <li onClick={() => setPage('tools')} className={(page === 'project' ? 'pill pill--selected' : 'pill')}>
            <div className="pill__icon">
              <img src={iconLegal} alt="tools" />
            </div>
            <div className='pill__title'>
              Project
            </div>
          </li>}
          <li onClick={(e)=>{
            setHideDrawer(true)
            layers()
            }} className={(page === 'layers' ? 'pill pill--selected' : 'pill')}>
            <div className="pill__icon">
              <LayersIcon className='nav-bar-icon'/>
            </div>
            <br />
            <div className='pill__title'>
              Layers
            </div>
          </li>

          <li onClick={openMenu} className={(page === 'tools' ? 'pill pill--selected' : 'pill')}>
            <div className="pill__icon">
              <BuildIcon className='nav-bar-icon'/>
            </div>
            <br />
            <div className='pill__title'>
              Tools
            </div>
          </li>
            <ToolsMenu anchor={anchorEl} open={open} onClose={handleClose} pageConfig={pageConfig} setHideDrawer={setHideDrawer} tools={tools}/>
          <li onClick={
            ()=>{
              setHideDrawer(true)
            identify()
            }
            } style={{ cursor: "pointer" }} className={(page === 'identify' ? 'pill pill--selected' : 'pill')}>
            <div className="pill__icon">
              <InfoIcon className='nav-bar-icon'/>
            </div>
            <br />
            <div className='pill__title'>
              Identify
            </div>
          </li>

          <li onClick={()=>{
            setHideDrawer((true))
            selection()
          }
            } className={(page === 'selection' ? 'pill pill--selected' : 'pill')}>
            <div className="pill__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 25.25 25.25">
                <g id="Group_6580" data-name="Group 6580" transform="translate(-4.9 -4.9)">
                  <path id="Line_420" data-name="Line 420" d="M0,3.234a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.734A.5.5,0,0,1,0,3.234Z" transform="translate(5.4 12.127)" fill="#fff" />
                  <path id="Line_421" data-name="Line 421" d="M0,3.182a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.682A.5.5,0,0,1,0,3.182Z" transform="translate(5.4 18.295)" fill="#fff" />
                  <path id="Path_5790" data-name="Path 5790" d="M5.4,8.818V5.4H8.818" transform="translate(0 0)" fill="#fff" />
                  <path id="Path_5790_-_Outline" data-name="Path 5790 - Outline" d="M5.4,9.318a.5.5,0,0,1-.5-.5V5.4a.5.5,0,0,1,.5-.5H8.818a.5.5,0,0,1,0,1H5.9V8.818A.5.5,0,0,1,5.4,9.318Z" transform="translate(0 0)" fill="#fff" />
                  <path id="Path_5791" data-name="Path 5791" d="M8.818,52.665H5.4V49.3" transform="translate(0 -25.316)" fill="#fff" />
                  <path id="Path_5791_-_Outline" data-name="Path 5791 - Outline" d="M8.818,53.165H5.4a.5.5,0,0,1-.5-.5V49.3a.5.5,0,0,1,1,0v2.865H8.818a.5.5,0,0,1,0,1Z" transform="translate(0 -25.316)" fill="#fff" />
                  <path id="Path_5792" data-name="Path 5792" d="M49.3,5.4h3.365V8.818" transform="translate(-25.316 0)" fill="#fff" />
                  <path id="Path_5792_-_Outline" data-name="Path 5792 - Outline" d="M52.665,9.318a.5.5,0,0,1-.5-.5V5.9H49.3a.5.5,0,0,1,0-1h3.365a.5.5,0,0,1,.5.5V8.818A.5.5,0,0,1,52.665,9.318Z" transform="translate(-25.316 0)" fill="#fff" />
                  <path id="Line_422" data-name="Line 422" d="M2.734.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H2.734a.5.5,0,0,1,.5.5A.5.5,0,0,1,2.734.5Z" transform="translate(12.127 5.4)" fill="#fff" />
                  <path id="Line_423" data-name="Line 423" d="M2.682.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H2.682a.5.5,0,0,1,.5.5A.5.5,0,0,1,2.682.5Z" transform="translate(18.295 5.4)" fill="#fff" />
                  <path id="Line_424" data-name="Line 424" d="M2.734.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H2.734a.5.5,0,0,1,.5.5A.5.5,0,0,1,2.734.5Z" transform="translate(12.127 27.349)" fill="#fff" />
                  <path id="Line_425" data-name="Line 425" d="M0,3.234a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.734A.5.5,0,0,1,0,3.234Z" transform="translate(27.349 12.127)" fill="#fff" />
                  <path id="Path_5793" data-name="Path 5793" d="M39.517,28.914,24.8,24.8l4.114,14.717,2.925-5.3,6.49,6.49,2.377-2.377-6.49-6.49Z" transform="translate(-11.306 -11.306)" fill="#fff" />
                  <path id="Path_5793_-_Outline" data-name="Path 5793 - Outline" d="M24.8,24.05a.749.749,0,0,1,.2.028l14.717,4.114a.75.75,0,0,1,.16,1.379l-4.429,2.443L41.236,37.8a.75.75,0,0,1,0,1.061l-2.377,2.377a.75.75,0,0,1-1.061,0l-5.785-5.785L29.57,39.88a.75.75,0,0,1-1.379-.16L24.078,25a.75.75,0,0,1,.722-.952Zm12.75,5.092L25.881,25.881,29.142,37.55l2.04-3.7a.75.75,0,0,1,1.187-.168l5.96,5.96,1.316-1.316-5.96-5.96a.75.75,0,0,1,.168-1.187Z" transform="translate(-11.306 -11.306)" fill="#fff" />
                </g>
              </svg>
            </div>
            <br />
            <div className='pill__title'>
              Selection
            </div>
          </li>
                    {pageConfig.widgets?.opMaintInspectionTools?.show&&<li onClick={
            ()=>{
              setHideDrawer(true)
            seniorInspReview("seniorInspReview")
            }
            } style={{ cursor: "pointer" }} className={(page === 'seniorInspReview' ? 'pill pill--selected' : 'pill')}>
            <div className="pill__icon">
              < ComputerIcon className='nav-bar-icon'/>
            </div>
            <br />
            <div className='pill__title'>
              SI Review
            </div>
          </li>}
          {pageConfig.widgets?.monuments?.show&&<li onClick={openMonumentMenu}
            className={(page === 'monuments' ? 'pill pill--selected' : 'pill')}>
            <div className="pill__icon">
            <img alt='light mode' src={IconMonuments}></img>
            </div>
            <div className='pill__title'>
              Monuments
            </div>
          </li>}
          <MonumentMenu anchor={monMenuAnchorEl} open={monMenuOpen} onClose={handleClose} pageConfig={pageConfig}setHideDrawer={setHideDrawer} tools={monuments}></MonumentMenu>
        </ul>
      </Nav>

      <ul className='nav__list--bottom'>
        {pageConfig.widgets.bugReport && <li onClick={() => setOpen(true)} className={(page === 'bugreport' ? 'pill pill--selected' : 'pill')}>
          <div className="pill__icon">
            <img src={report} alt="tools" />
          </div>
          <div className='pill__title'>
            Bug Report
          </div>
        </li>}
        <li onClick={()=>window.open('https://www.youtube.com/@OCGISAppDev', '_blank')} className={(page === 'tools' ? 'pill' : 'pill')}>
            <div className="pill__icon">
              <YouTubeIcon className='nav-bar-icon'/>
            </div>
            <br />
            <div className='pill__title'>
              Tutorials
            </div>
          </li>

        <li className={(page === 'mode' ? 'pill pill--selected' : 'pill')}>
          <ThemeProvider theme={isDarkTheme ? darkTheme : lightTheme}>
            <GlobalStyles />
            <p style={{ fontSize: "25px", cursor: "pointer", textAlign: "center" }} onClick={toggleTheme}>
              {isDarkTheme ? (
                <span aria-label="Light mode" role="img">
                  <img alt='light mode' src={iconLightMode}></img>
                  <span style={{  fontSize:"11px", fontWeight:"bold", color:"white", display:"block"}}>Light Mode</span>
                </span>
              ) : (
                <span aria-label="Dark mode" role="img">
                  <img alt='dark mode' src={iconDarkMode}></img>
                  <span style={{  fontSize:"11px", fontWeight:"bold", color:"white", display:"block"}}>Dark Mode</span>
                </span>
              )}
            </p>
          </ThemeProvider>
        </li>
        <br />
        <li><p className='version'>ver. {appVersion}</p></li>
        <li onClick={() => setHideDrawer(hideDrawer ? false : true)}>
          <div className="nav__list__arrow">
            <img alt="Hide Drawer" src={(hideDrawer === false ? hide : show)} className="icon--nav"></img>
          </div>
        </li>
      </ul>
    </div>
  )

}

export default NavMenu
